/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Sixense */
import { BydModel } from '@sixense/byd-core-service';
/** Models */
import { DsLinearWorkFormLink } from '../models/ds-linear-work-form-link';
/** Interfaces */
import { DsLinearWorkFormLinkInterface } from '../interfaces/ds-linear-work-form-link.interface';

@Injectable({
  providedIn: 'root',
})
export class DsLinearWorkFormLinksService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get selected linear work form template links.
   *
   * @param projectId Selected project id
   * @param workId Selected linear work id
   * @param elementsPerPage Elements per page
   * @param pageIndex Page index
   * @returns Observable<BydModel<DsLinearWorkFormLink>>
   */
  public getLinks(
    projectId: number,
    workId: number,
    elementsPerPage = 10,
    pageIndex = 0
  ): Observable<BydModel<DsLinearWorkFormLink>> {
    this.path = `/v1/projects/${projectId}/works/${workId}/forms`;
    const headers = this.bydRhsHeadersService.setHeadersWithPagination(elementsPerPage, pageIndex);
    return this.getModels<DsLinearWorkFormLink>({ headers });
  }

  /**
   * Create DsLinearWorkFormLink instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsLinearWorkFormLink` instance.
   */
  public createNewInstance(jsonObject: DsLinearWorkFormLinkInterface): DsLinearWorkFormLink {
    return new DsLinearWorkFormLink(jsonObject);
  }
}
